import { createFileRoute, redirect } from '@tanstack/react-router'
import { authManager } from '../auth-manager.ts'

export const Route = createFileRoute('/_redirects')({
	async beforeLoad() {
		if (!authManager.isAuthenticated()) {
			throw redirect({ to: '/login', search: { returnTo: location.pathname + location.search + location.hash } })
		}
	},
})
